import React from 'react'
import * as S from "./styles"
import { FutButton } from '@/components/FutButton'
import { useNavigate } from 'react-router-dom';

export default function AfterRegister() {
  const navigate = useNavigate();
  return (
    <S.ThanksWrapper>
      <S.ThanksBox>
        <h2>Registrado com sucesso!</h2>
        <p>Por motivos de segurança, Enviamos um link <b>no seu email</b> para você fazer o pagamento</p>
        <FutButton onClick={() => navigate("/login")}>Voltar para tela de login</FutButton>
      </S.ThanksBox>
    </S.ThanksWrapper>
  )
}

